import { Products } from '@/shared/types/Billing';

import { BASE_URL } from '../constants';
import { get, post } from '../requestMethods';
import {
  IApplyPromoRequest,
  IApplyPromoResponse,
  ICreateSubscriptionIntentRequest,
  ICreateSubscriptionIntentResponse,
  IGetCheckoutSessionResponse,
  IGetLatestPaymentInfoResponse,
  IGetPaymentSessionRequestData,
  IGetSubscriptionSessionRequestData,
  IPortalUpgradeRequest,
} from './types';

const URL = `${BASE_URL}/api/payments`;

export const BILLING_API = {
  applyPromoCode: (data: IApplyPromoRequest) => post<IApplyPromoResponse>(`${URL}/promotion_code`, { data }),

  // Upgrade subscription (GET with query params)
  upgradePortal: ({ new_price_id, return_url, success_url }: IPortalUpgradeRequest) =>
    get<IGetCheckoutSessionResponse>(
      `${URL}/portal/upgrade?new_price_id=${new_price_id}&return_url=${encodeURIComponent(
        return_url,
      )}&success_url=${encodeURIComponent(success_url)}`,
    ),

  // Cancel Subscription Cancellation (Pending Cancellation state)
  cancelSubscriptionCancellation: () => post<{ ok: boolean }>(`${URL}/cancel_subscription_cancellation`),

  createSubscriptionIntent: (data: ICreateSubscriptionIntentRequest) =>
    post<ICreateSubscriptionIntentResponse>(`${URL}/subscription`, { data }),

  getBuyCreditsCheckoutUrl: ({ id, quantity, success_url, cancel_url }: IGetPaymentSessionRequestData) =>
    get<IGetCheckoutSessionResponse>(
      `${URL}/create_checkout_session_payment?price_id=${id}&quantity=${quantity}&success_url=${success_url}&cancel_url=${cancel_url}`,
    ),

  // Buy subscription or minutes
  getBuySubscriptionCheckoutUrl: ({ id, success_url, cancel_url }: IGetSubscriptionSessionRequestData) =>
    get<IGetCheckoutSessionResponse>(
      `${URL}/create_checkout_session_subscription?price_id=${id}&success_url=${success_url}&cancel_url=${cancel_url}`,
    ),

  // Get link to Customer Portal
  getCustomerPortal: (url: string) => get<{ billing_portal_url: string }>(`${URL}/billing_portal?return_url=${url}`),

  // Other
  getLatestPaymentInfo: () => get<IGetLatestPaymentInfoResponse>(`${URL}/latest_payment_info`),

  // Get all plans
  getPlans: () => get<Products>(`${URL}/products`),

  // Update customer billing details
  updateCustomerBillingDetails: (data: { [key: string]: object | string }) =>
    post<{
      ok: boolean;
    }>(`${URL}/update_customer_billing_details`, { data }),
};
